import { render, staticRenderFns } from "./FormTrainingSystem.vue?vue&type=template&id=5bcc9537&scoped=true&"
import script from "./FormTrainingSystem.vue?vue&type=script&lang=js&"
export * from "./FormTrainingSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc9537",
  null
  
)

export default component.exports